export const storageNames = {
  zustand_end_auth_form: 'end-auth-zustand-form',
  zustand_create_project_info_form: 'zustand_create_project_info_form',
  zustand_create_project_state_form: 'zustand_create_project_state_form',
  zustand_create_project_dictionary_form: 'zustand_create_project_dictionary_form',
  zustand_create_project_promotion_channels: 'zustand_create_project_promotion_channels',
  zustand_create_project_problems_form: 'zustand_create_project_problems_form',
  zustand_diagnostic_form: 'zustand_diagnostic_form',
  zustand_right_sidebar: 'zustand_right_sidebar',
  zustand_left_sidebar: 'zustand_left_sidebar',
  zustand_hypotheses_filter: 'zustand_hypotheses_filter',
  zustand_hypotheses_create: 'zustand_hypotheses_create',
  zustand_stepper: 'zustand_stepper',
  zustand_dynamic_persisted_values: 'zustand_dynamic_persisted_values',
  zustand_select_chat_llm: 'zustand_select_chat_llm',
} as const
